export const genderTypeList = [
  { value: 0, label: "Female" },
  { value: 1, label: "Male" },
  { value: 2, label: "Transgender" },
  { value: 3, label: "Non-binary/non-conforming" },
  { value: 4, label: "Prefer not to respond" },
];
